import React from "react";
import {Button, Tooltip} from "antd";
import {useAreChangesMadeToDesign} from "../../../../../../../hooks/useAreChangesMadeToDesign";
import {FileText} from "@phosphor-icons/react";
import {setPathname} from "../../../../../../../helpers/storeHelpers";
import {useViewerStore} from "../../../../../../../store/store";

const EngineeringLetterButton: React.FC = () => {

    const {areChangesMade, isOriginalSite} = useAreChangesMadeToDesign();
    const setIsSidebar = (val: boolean) => useViewerStore.setState({isLeftSidebarOpen: val});


    const onClickEngLetter = () => {
        setPathname("/configure/building/engineering-letter");
        setIsSidebar(false);
    }

    return (
        <>
            <Tooltip
                title={areChangesMade ? "Changes were made. Finalize before downloading."
                    : isOriginalSite ? "Feature disabled for the Original design. Select a finalized design." : ""}>
                <Button
                    disabled={areChangesMade || isOriginalSite}
                    icon={<FileText size={20}/>}
                    type='primary' size='large' block onClick={onClickEngLetter}>Engineering Letter</Button>
            </Tooltip>
        </>
    )
}

export default EngineeringLetterButton;